import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { formatAUD } from '../../../utils/formatCurrency';
import '../styles/InventoryProducts.css';

function formatDate(raw) {
  if (!raw) return '—';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export default function ProductDetailModal({ item, onClose, onEdit }) {
  if (!item) return null;

  const status = item.status || {};
  const qty = `${item.onHand ?? 0} ${item.unit || ''}`.trim();

  return (
    <div className="ip-overlay" onClick={onClose}>
      <div
        className="ip-modal ip-modal--detail"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="ip-modal-header">
          <h2>Product — {item.code || item.name}</h2>
          <button
            type="button"
            className="ip-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </header>

        <div className="ip-modal-body">
          <div className="ip-badges">
            <span className="ip-code-badge">{item.code || 'No SKU'}</span>
            <span className={`ip-status ip-status--${status.key || 'in_stock'}`}>
              {status.label || 'In Stock'}
            </span>
          </div>

          <h3 className="ip-detail-title">{item.name}</h3>
          {item.description ? (
            <p className="ip-detail-desc">{item.description}</p>
          ) : null}

          <div className="ip-detail-cards">
            <div className="ip-detail-card">
              <b>Category</b>
              <span>{item.category || '—'}</span>
            </div>
            <div className="ip-detail-card">
              <b>Unit</b>
              <span>{item.unit || '—'}</span>
            </div>
            <div className="ip-detail-card">
              <b>Supplier</b>
              <span>{item.supplier || item.preferredSupplier || '—'}</span>
            </div>
            <div className="ip-detail-card">
              <b>Current stock</b>
              <span>{qty || '—'}</span>
            </div>
            <div className="ip-detail-card">
              <b>Reorder level</b>
              <span>{item.reorderLevel ?? '—'}</span>
            </div>
            <div className="ip-detail-card">
              <b>Max stock</b>
              <span>{item.maxStockLevel || '—'}</span>
            </div>
            <div className="ip-detail-card">
              <b>Cost / unit</b>
              <span>{item.cost ? formatAUD(item.cost) : '—'}</span>
            </div>
            <div className="ip-detail-card">
              <b>Expiry</b>
              <span>{formatDate(item.expiryDate)}</span>
            </div>
          </div>

          <div className="ip-banner">
            <strong>{qty || '0'}</strong> on hand
            {item.cost ? (
              <>
                {' '}
                · stock value{' '}
                <strong>
                  {formatAUD((Number(item.onHand) || 0) * item.cost)}
                </strong>
              </>
            ) : null}
            {item.supplier || item.preferredSupplier
              ? ` · supplied by ${item.supplier || item.preferredSupplier}`
              : ''}
            .
          </div>

          <div className="ip-modal-footer">
            <button type="button" className="ip-btn" onClick={onClose}>
              Close
            </button>
            <button
              type="button"
              className="ip-btn ip-btn--primary"
              onClick={() => onEdit?.(item)}
            >
              Edit Product
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
